<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title ref="titolo" class="text-h6">{{drawerTitle}}</v-list-item-title>
          <v-list-item-subtitle>{{drawerSubtitle}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item
          v-for="item in documentoItems"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component :is="'p' + item.type" :item="item" :appoggio="locRigaDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex justify-space-around" cols="12" sm="6" v-if="!readOnly">
            <v-badge bordered color="error" icon="mdi-lock" title="Verificare i dati inseriti" overlap :value="!formFieldsValid">
              <v-btn color="success mb-2" @click="onSalva" :disabled="!formFieldsValid">Salva</v-btn>
            </v-badge>
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla" >{{annullaTitle}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <dialog-conferma
        :show="dialogConferma"
        :title="titoloConferma"
        :message="messaggioConferma"
        @dialog-confirm="onConferma"
        @dialog-cancel="dialogConferma=false"
      />
    </template>
  </v-navigation-drawer>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
// import clienti from '@/services/clientiService.js'
import DialogConferma from '@/components/dialogConferma'

import pTesto from '@/views/drawer/elementi/testo'
import pQuattroValori from '@/views/drawer/elementi/quattroValori'
import pTextArea from '@/views/drawer/elementi/textArea'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pData from '@/views/drawer/elementi/data'
import pProdotto from '@/views/drawer/elementi/prodotto'
import pSwitch from '@/views/drawer/elementi/switch'
// import pClifor from '@/views/drawer/elementi/clifor'
// import pDestinazioni from '@/views/drawer/elementi/destinazioni'

export default {
  components: {
    DialogConferma,
    pTesto,
    pQuattroValori,
    pTextArea,
    pMultiselect,
    pData,
    pProdotto,
    pSwitch
    // pClifor,
    // pDestinazioni
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    locRigaDocumento: null,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    this.locRigaDocumento = this.$store.getters['documentiDettaglio/rigaDocumento'] || null
    // if (this.locRigaDocumento) {
    this.updateTrigger++
    // }
  },
  watch: {
    documento(value) {
      this.locRigaDocumento = value
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza riga'
      } else {
        return this.locRigaDocumento && this.locRigaDocumento._id ? 'Modifica riga' : 'Nuova riga'
      }
    },
    drawerSubtitle() {
      return this.updateTrigger ? _.get(this.locRigaDocumento, 'tipoDocumento.descrizione', '') : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    documento() {
      return this.$store.getters['documentiDettaglio/rigaDocumento'] || null // || { codice: '', descrizione: '' }
    },
    documentoItems() {
      if (!this.locRigaDocumento || !this.backoffice || !this.updateTrigger) {
        return []
      }
      const vars = this.backoffice.documentiDettaglio
      const items = []
      for (const item of vars) {
        if (item.type === 'QuattroValori') { // TODO: generalizzare: mettere array + isArray ...
          items.push({
            value1: dot.pick(item.valueField1, this.locRigaDocumento),
            value2: dot.pick(item.valueField2, this.locRigaDocumento),
            value3: dot.pick(item.valueField3, this.locRigaDocumento),
            value4: dot.pick(item.valueField4, this.locRigaDocumento), ...item})
        } else {
          items.push({value: dot.pick(item.valueField, this.locRigaDocumento), ...item})
        }
      }
      return items
    }
/*     nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    } */
  },
  methods: {
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value[subModel]
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locRigaDocumento, tgt)
      await this.aggiornaCorrelati(data)
      this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.locRigaDocumento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      this.locRigaDocumento.appoggio = this.locRigaDocumento.appoggio || {}
      let tipoModifica = ''
      switch (data.model) {
        case 'prodotto.codice':
          this.locRigaDocumento.appoggio.prodotto = data.item
          this.locRigaDocumento.descrizione = `${data.item.descrizione} ${_.get(data.item, 'variante2.descrizione', '')} ${_.get(data.item, 'variante1.descrizione', '')}`
          if (this.locRigaDocumento.appoggio.importiModificati) { // La prima volta, devo rileggere il prodotto ma non impostare il listino. Se cambio prodotto, si
            this.locRigaDocumento.appoggio.importiModificati = false
            this.updateTrigger++
            return
          }
          this.locRigaDocumento.tipoBene = data.item.item.tipoBene
          this.locRigaDocumento.repartoFiscale = data.item.datiFiscali.reparto.stampante
          break;
        case 'rigaDescrittiva':
          delete this.locRigaDocumento.appoggio.prodotto
          delete this.locRigaDocumento.prodotto
          this.locRigaDocumento.valore.prezzoUnitario = 0
          this.locRigaDocumento.appoggio.rigaDescrittiva = data.value       
          this.locRigaDocumento.descrizione = ''
          break;
        case 'valore.listino':
          _.set(this.locRigaDocumento,'appoggio.listino.ivato', _.get(data,'value.ivato', true))
          _.set(this.locRigaDocumento,'appoggio.listino.nonIvato', !_.get(data,'value.ivato', true))
          break;
        case 'valore.sconto1':
        case 'valore.sconto2':
        case 'valore.sconto3':
        case 'valore.sconto4':
          this.locRigaDocumento.sconti = this.rigaSconti(this.locRigaDocumento.valore)
          tipoModifica = data.model
          break;
        case 'valore.prezzoUnitario':          
        case 'valore.prezzoTotale':
        case 'valore.prezzoNettoUnitario':
        case 'valore.prezzoNettoTotale':
        case 'valore.importoUnitario':
        case 'valore.importoTotale':
        case 'valore.importoNettoUnitario':
        case 'valore.importoNettoTotale':
          tipoModifica = data.model
          this.locRigaDocumento.valore.importiModificati = true // viene messo su appoggio alla successiva riapertura della riga
          break;        
        case 'aliquotaIva':
        case 'quantita':          
          break;
        default:
          break
      }
      this.aggiornaValori(tipoModifica)
      this.updateTrigger++      
    },
    rigaSconti(v) {
      const sc = []
      v.sconto1 && sc.push (v.sconto1)
      v.sconto2 && sc.push (v.sconto2)
      v.sconto3 && sc.push (v.sconto3)
      v.sconto4 && sc.push (v.sconto4)
      return sc.join('+')
    },
    aggiornaValori(tipoModifica) {
      const rd = _.get(this.locRigaDocumento,'appoggio.rigaDescrittiva', false)
      const prd = _.get(this.locRigaDocumento,'appoggio.prodotto', {})
      const lst = _.get(this.locRigaDocumento,'valore.listino.codice', '')
      const ivato = rd ? true : _.get(this.locRigaDocumento,'valore.listino.ivato', true) // Verificare come gestire se riga descrittiva
      let pl = rd ? parseFloat(_.get(this.locRigaDocumento,'valore.prezzoUnitario', 0)) : _.get(prd, `prezzoItem.${lst}.base`, 0)
      const qta = parseFloat(_.get(this.locRigaDocumento,'quantita', 0))
      let sc1 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto1', 0) || '0')
      let sc2 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto2', 0) || '0')
      let sc3 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto3', 0) || '0')
      let sc4 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto4', 0) || '0')
      let sconto = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
      const iva = _.get(prd,'datiFiscali.aliquoteIva[0]', {})
      if (!this.locRigaDocumento.aliquotaIva) { // Modifico solo se non ho l'aliquota forzata dal cliente
        this.locRigaDocumento.aliquotaIva = iva
      }
      const aliquota = this.locRigaDocumento.aliquotaIva.valore || this.locRigaDocumento.aliquotaIva.aliquota
      // verificare se listino ivato o non ivato
      const aggiornaSconti = true // da impostazioni scelgo se aggiornare gli sconti o il prezzo di listino nel caso di modifica dell'importo
      if (ivato) {
        switch (tipoModifica) {
          case 'valore.prezzoUnitario':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
            break;
          case 'valore.prezzoTotale':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoTotale) / qta
            break;
          case 'valore.prezzoNettoUnitario':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) * ( 1 + aliquota / 100)
            break;
          case 'valore.prezzoNettoTotale':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoTotale) * ( 1 + aliquota / 100) / qta
            break;
          case 'valore.importoUnitario':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoUnitario) / oldPl
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / sconto
            } else {
              pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / sconto
            }
            break;
          case 'valore.importoTotale':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoTotale) / (oldPl * qta)
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
            } else {
              pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
            }
            break;
          case 'valore.importoNettoUnitario':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / oldPl
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
            } else {
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
            }
            break;
          case 'valore.importoNettoTotale':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (oldPl * qta)
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
            } else {
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
            }
            break; 
          case 'valore.sconto1':
          case 'valore.sconto2':
          case 'valore.sconto3':
          case 'valore.sconto4':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) || pl
            break;
          default:
            // pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) || pl
            break;
        }
        this.locRigaDocumento.valore.prezzoUnitario = pl ? pl.toFixed(2) : ''
        // this.locRigaDocumento.valore.prezzoTotale = qta && pl ? (pl * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.prezzoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.prezzoUnitario)).toFixed(2) : ''
        this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? (pl / ( 1 + aliquota / 100)).toFixed(2) : ''
        // this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? ((pl / ( 1 + aliquota / 100)) * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)).toFixed(2) : ''

        this.locRigaDocumento.valore.importoUnitario = pl ? (pl * sconto).toFixed(2) : ''
        // this.locRigaDocumento.valore.importoTotale = qta && pl ? (pl * sconto * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.importoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.importoUnitario)).toFixed(2) : ''
        this.locRigaDocumento.valore.importoNettoUnitario = pl ? ((pl / ( 1 + aliquota / 100)) * sconto).toFixed(2) : ''
        // this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? ((pl / ( 1 + aliquota / 100)) * sconto * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.importoNettoUnitario)).toFixed(2) : ''
      } else {
       switch (tipoModifica) {
          case 'valore.prezzoUnitario':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) / ( 1 + aliquota / 100)
            break;
          case 'valore.prezzoTotale':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoTotale) / ( 1 + aliquota / 100) / qta
            break;
          case 'valore.prezzoNettoUnitario':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
            break;
          case 'valore.prezzoNettoTotale':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoTotale) / qta
            break;
          case 'valore.importoUnitario':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / oldPl
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
            } else {
              // pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) / sconto
              pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
            }
            break;
          case 'valore.importoTotale':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (oldPl * qta)
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
            } else {
              // pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
              pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
            }
            break;
          case 'valore.importoNettoUnitario':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / oldPl
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / sconto
            } else {
              // pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / sconto
            }
            break;
          case 'valore.importoNettoTotale':
            if (aggiornaSconti) {
              let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
              let oldSc = sconto
              sconto = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (oldPl * qta)
              this.rielaboraSconti(oldSc, sconto)
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (sconto * qta)
            } else {
              // pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (sconto * qta)
            }
            break;
          case 'valore.sconto1':
          case 'valore.sconto2':
          case 'valore.sconto3':
          case 'valore.sconto4':
            pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) || pl
            break;
          default:
            // pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) || pl
            break;
        }        
        this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? pl.toFixed(2) : ''
        // this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? (pl * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)).toFixed(2) : ''
        this.locRigaDocumento.valore.prezzoUnitario = pl ? (pl * ( 1 + aliquota / 100)).toFixed(2) : ''
        // this.locRigaDocumento.valore.prezzoTotale = qta && pl ? ((pl * ( 1 + aliquota / 100)) * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.prezzoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.prezzoUnitario)).toFixed(2) : ''

        this.locRigaDocumento.valore.importoNettoUnitario = pl ? (pl * sconto).toFixed(2) : ''
        // this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? (pl * sconto * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.importoNettoUnitario)).toFixed(2) : ''

        this.locRigaDocumento.valore.importoUnitario = pl ? ((pl * ( 1 + aliquota / 100)) * sconto).toFixed(2) : ''
        // this.locRigaDocumento.valore.importoTotale = qta && pl ? ((pl * ( 1 + aliquota / 100)) * sconto * qta).toFixed(2) : ''
        this.locRigaDocumento.valore.importoTotale = qta && pl ? (qta * parseFloat(this.locRigaDocumento.valore.importoUnitario)).toFixed(2) : ''
      }
    },
    rielaboraSconti(oldSc, sconto) {
      let sc1 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto1', 0) || '0')
      let sc2 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto2', 0) || '0')
      let sc3 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto3', 0) || '0')
      let sc4 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto4', 0) || '0')

      let newSc = 1
      if (sconto < oldSc) {
        sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
        _.set(this.locRigaDocumento,'valore.sconto4', sc4.toFixed(2))
      } else {
        if (sc4) {
          sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
          if (sc4 < 0) sc4 = 0
            _.set(this.locRigaDocumento,'valore.sconto4', sc4.toFixed(2))
        }
        newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
        if (newSc < sconto && sc3) {
          sc3 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc4 / 100))) * 100
          if (sc3 < 0) sc3 = 0
            _.set(this.locRigaDocumento,'valore.sconto3', sc3.toFixed(2))
        }
        newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
        if (newSc < sconto && sc2) {
          sc2 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
          if (sc2 < 0) sc2 = 0
            _.set(this.locRigaDocumento,'valore.sconto2', sc2.toFixed(2))
        }
        newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)                
        if (newSc < sconto && sc1) {
          sc1 = (1 - sconto / ((1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
          // if (sc1 < 0) sc1 = 0 // Non cancello, se minore di zero è una Maggiorazione
            _.set(this.locRigaDocumento,'valore.sconto1', sc1.toFixed(2))
        }
      }
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('documenti/SET_REFRESH')
      this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        this.pulisciSeNotaDescrittiva() 
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.locRigaDocumento)
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO_SAVED')
      }
    },
    pulisciSeNotaDescrittiva() {
      if (_.get(this.locRigaDocumento,'appoggio.rigaDescrittiva', false) && parseFloat(_.get(this.locRigaDocumento,'quantita', 0)) === 0) {
        _.set(this.locRigaDocumento,'valore.sconto1', '')
        _.set(this.locRigaDocumento,'valore.sconto2', '')
        _.set(this.locRigaDocumento,'valore.sconto3', '')
        _.set(this.locRigaDocumento,'valore.sconto4', '')
        _.set(this.locRigaDocumento,'sconti', '')
      }
    }
  }
}
</script>